import object from 'helpers/object'
import moment from 'moment'

const year = new Date().getFullYear()
const month = new Date().getMonth()


const _initialState = {
  list: {
    buses: [],
    dates: [],
    routes: [],
    contractors: [
      'Горавтотранс',
    ],
  },
  report: {
    // contractor: null,
    // bus: null,
    // route: null,
    date: {
      from: moment([ year, month ]).toDate(),
      to: new Date(),
    },
  },
  violation: {
    date: {
      from: moment([ year, month ]).toDate(),
      to: new Date(),
    },
  },
  deviation: {
    date: {
      from: moment([ year, month ]).toDate(),
      to: new Date(),
    },
  },
}

export const initialState = _initialState

export const clear = (state, payload) =>
  object.setIn(state, [ payload.type ], _initialState[payload.type])

export const setDate = (state, payload) =>
  object.setIn(state, [ payload.type, 'date' ], payload.data)

export const setBus = (state, payload) =>
  object.setIn(state, [ payload.type, 'bus' ], payload.data)

export const setRoute = (state, payload) =>
  object.setIn(state, [ payload.type, 'route' ], payload.data)

export const setContractor = (state, payload) =>
  object.setIn(state, [ payload.type, 'contractor' ], payload.data)

export const setList = (state, payload) =>
  object.setIn(state, [ 'list', payload.listName ], payload.data)
